<template>
  <div>

      <!--顶部工具条-->
      <el-col :span="24">
        <el-form :inline="true">
          <el-form-item label="用户姓名:">
            <el-input
              v-model="filters.name"
              placeholder="请输入"
              style="width: 120px"
              clearable
            />
          </el-form-item>
          <el-form-item label="手机号:">
            <el-input
              v-model="filters.phoneNumber"
              placeholder="请输入"
              style="width: 120px"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <toolbar
              :buttonList="buttonList"
              @callFunction="callFunction"
            ></toolbar>
          </el-form-item>
        </el-form>
      </el-col>
      <!--列表-->
      <el-table
        :data="tableData"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%"
        border
        class="custom-padding-table"
      >
        <el-table-column
          prop="loginDate"
          label="登录时间"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="name"
          label="用户名"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="phoneNumber"
          label="手机号"
          align="center"
          show-overflow-tooltip
        ></el-table-column>

      </el-table>
      <!--底部工具条-->
      <el-col :span="24" class="pageBar">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pages.pageIndex"
          :page-sizes="pages.pageArr"
          :page-size="pages.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pages.dataCount"
        >
        </el-pagination>
      </el-col>

   
  </div>
</template>

<script>
import util from "../../../util/date";
import {
  getLoginLogList,

} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import Qs from "qs";
export default {
  components: { Toolbar },
  data() {
    return {
      util: "",
      tableData: [],
      listLoading: false,
      //增删改查按钮
      buttonList: [],
      //顶部筛选条件
      filters: {
        name: "",
        phoneNumber: ""
      },
      
      //关于分页的obj
      pages: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
      
    };
  },
  methods: {
     handleSearch() {
      this.pages.pageIndex = 1;
      this.pages.pageSize = 20;
      this.getList();
    },
   
    
    formatCreateTime: function (date) {
      return !date || date == ""
        ? ""
        : util.formatDate.format(new Date(date), "yyyy-MM-dd");
    },
    

   

    //获取用户统计列表
    getList() {
      this.listLoading = true;
      let params = {
        ...this.filters,    
        pageIndex: this.pages.pageIndex,
        pageSize: this.pages.pageSize
      };
      getLoginLogList(params).then((res) => {
        console.log('res',res)
        this.tableData = res.data.response.data;
        this.listLoading = false;
        this.pages.dataCount = res.data.response.dataCount;
      });
    },

    // apply改变this指向
    callFunction(item) {
      this[item.func].apply(this, item);
    },
    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getList();
    },
  },
  mounted() {
    this.getList();
    this.util = util;
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
<style lang="stylus" scoped>
.pageBar {
  margin-top: 15px;
}


/* 👇👇👇 新增的样式开始 👇👇👇 */
.custom-padding-table
  ::v-deep .el-table__cell
    /* 上下内边距，根据需要调整数值，默认通常是 8px 或 10px */
    padding-top: 16px
    padding-bottom: 16px
    
  /* 如果上面的写法在某些构建环境下不生效，可以尝试加 !important 强制覆盖 */
  ::v-deep td.el-table__cell
    padding-top: 16px !important
    padding-bottom: 16px !important
/* 👆👆👆 新增的样式结束 👆👆👆 */
</style>
